module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "60px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "inbox"
  }, [_c('page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("缩略图 组件 thumbnail")])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "data": _vm.$store.state.bcArray
    }
  })]), _vm._v(" "), _c('bsfcol', {
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_c('panel', {
    attrs: {
      "header": "缩略图组件"
    }
  }, [_c('thumbnail', {
    attrs: {
      "unbd": true
    },
    slot: "body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png")
    },
    slot: "img"
  }), _vm._v(" "), _c('template', {
    slot: "caption"
  }, [_c('h4', [_vm._v("thumbnail label name")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")])])], true)])]), _vm._v(" "), _c('bsfcol', {
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_c('panel', {
    attrs: {
      "header": "缩略图组件 只有图片"
    }
  }, [_c('thumbnail', {
    slot: "body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png")
    },
    slot: "img"
  })])])]), _vm._v(" "), _c('bsfcol', {
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_c('panel', {
    attrs: {
      "header": "缩略图组件 只有caption"
    }
  }, [_c('thumbnail', {
    slot: "body"
  }, [_c('template', {
    slot: "caption"
  }, [_c('h4', [_vm._v("thumbnail label name")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")])])], true)])]), _vm._v(" "), _c('bsfcol', {
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_c('panel', {
    attrs: {
      "header": "缩略图组件 没有边框"
    }
  }, [_c('thumbnail', {
    slot: "body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png")
    },
    slot: "img"
  }), _vm._v(" "), _c('template', {
    slot: "caption"
  }, [_c('h4', [_vm._v("thumbnail label name")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")])])], true)])]), _vm._v(" "), _c('bsfcol', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('panel', {
    attrs: {
      "header": "缩略图组件 和swiper组件结合使用",
      "tooltip": true
    }
  }, [_c('thumbnail', {
    attrs: {
      "unbd": true
    },
    slot: "body"
  }, [_c('swiper', {
    attrs: {
      "height": "300",
      "mouse": ""
    },
    slot: "img"
  }, _vm._l((_vm.swiperData), function(slider, index) {
    return _c('div', {
      staticClass: "swiper-slide",
      slot: "slide"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/logo.png")
      },
      slot: "img"
    })])
  })), _vm._v(" "), _c('template', {
    slot: "caption"
  }, [_c('h4', [_vm._v("thumbnail label name")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")])])], true)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-243ccba6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/comp/thumbnail.vue
// module id = 296
// module chunks = 2